import { render, staticRenderFns } from "./SettingAccountSignupLogin.vue?vue&type=template&id=37f1326d&scoped=true&"
import script from "./SettingAccountSignupLogin.vue?vue&type=script&lang=js&"
export * from "./SettingAccountSignupLogin.vue?vue&type=script&lang=js&"
import style0 from "./SettingAccountSignupLogin.vue?vue&type=style&index=0&id=37f1326d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f1326d",
  null
  
)

export default component.exports